var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "flex col-6" },
          [
            _c("h2", { staticClass: "l-header-2 rates" }, [_vm._v("Rates")]),
            _vm._v(" "),
            _vm.job.contract_signed
              ? _c("customTooltip", {
                  attrs: { config: { placement: "right" } },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var isOpen = ref.isOpen
                        var open = ref.open
                        var close = ref.close
                        return _c(
                          "div",
                          {
                            staticClass: "tooltip",
                            on: { mouseover: open, mouseleave: close }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-file rates-icon",
                              attrs: { "data-trigger": "" }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: isOpen,
                                    expression: "isOpen"
                                  }
                                ],
                                staticClass: "custom-tooltip",
                                attrs: { "data-popper": "" }
                              },
                              [
                                _c("div", {
                                  staticClass: "border-black",
                                  attrs: { "x-arrow": "" }
                                }),
                                _vm._v(
                                  "\n            Pre-move agreement signed\n          "
                                )
                              ]
                            )
                          ]
                        )
                      }
                    }
                  ])
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 text-right" }, [
          !_vm.editableFields && _vm.isActive && _vm.$_can("jobs.change")
            ? _c(
                "button",
                {
                  staticClass: "btn btn-change",
                  attrs: { type: "button", disabled: !_vm.hasAccess },
                  on: { click: _vm.setEditableFields }
                },
                [
                  _c("i", {
                    staticClass: "fa fa-pencil mr-1",
                    attrs: { "aria-hidden": "true" }
                  }),
                  _vm._v("Change\n      ")
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row my-3 rates-wrapper" }, [
        _c(
          "div",
          {
            staticClass:
              "col-12 col-lg-4 col-md-4 col-xl-4 pr-lg-2 pr-md-2 pr-xl-2 mb-3 mb-xl-0 mb-lg-0 mb-md-0"
          },
          [
            _c(
              "div",
              { staticClass: "select-wrap" },
              [
                _c("label", [_vm._v("Move date")]),
                _vm._v(" "),
                _c("flat-pickr", {
                  staticClass: "form-control",
                  staticStyle: { visibility: "hidden" },
                  attrs: {
                    config: _vm.config,
                    disabled: _vm.isFlatRate,
                    placeholder: "Select date",
                    red: "flatPickr",
                    "data-input": ""
                  },
                  on: {
                    "on-close": _vm.closedDatePickr,
                    "on-change": _vm.updateOffers
                  },
                  model: {
                    value: _vm.job.move_date_new,
                    callback: function($$v) {
                      _vm.$set(_vm.job, "move_date_new", $$v)
                    },
                    expression: "job.move_date_new"
                  }
                }),
                _vm._v(" "),
                !_vm.job.move_date_new
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.job.move_date,
                          expression: "job.move_date"
                        }
                      ],
                      staticClass:
                        "form-control flatpickr-input-sec pointer select-date-input",
                      attrs: {
                        placeholder: "Select date",
                        disabled: !_vm.editableFields || _vm.isFlatRate,
                        "data-toggle": ""
                      },
                      domProps: { value: _vm.job.move_date },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.job, "move_date", $event.target.value)
                        }
                      }
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.job.move_date_new,
                          expression: "job.move_date_new"
                        }
                      ],
                      staticClass:
                        "form-control flatpickr-input-sec pointer select-date-input",
                      attrs: {
                        placeholder: "Select date",
                        disabled: !_vm.editableFields || _vm.isFlatRate,
                        "data-toggle": ""
                      },
                      domProps: { value: _vm.job.move_date_new },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.job,
                            "move_date_new",
                            $event.target.value
                          )
                        }
                      }
                    })
              ],
              1
            ),
            _vm._v(" "),
            _c("error-field", {
              attrs: { errors: _vm.errors, field: "move_date" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-12 col-lg-4 col-md-4 col-xl-4 px-lg-2 px-md-2 px-xl-2"
          },
          [
            _c(
              "div",
              { staticClass: "select-wrap" },
              [
                _c("label", [_vm._v("Arrival window")]),
                _vm._v(" "),
                _c("simple-select", {
                  attrs: {
                    options: _vm.arrivalWindows,
                    disabled: !_vm.editableFields || _vm.isFlatRate,
                    label: "label",
                    placeholder: "Select Arrival Window"
                  },
                  on: { input: _vm.updateOffers },
                  model: {
                    value: _vm.job.arrival_window_id,
                    callback: function($$v) {
                      _vm.$set(_vm.job, "arrival_window_id", $$v)
                    },
                    expression: "job.arrival_window_id"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("error-field", {
              attrs: { errors: _vm.errors, field: "arrival_window_id" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-3 col-lg-1 col-md-1 col-xl-1 pr-0 pl-lg-2 pl-md-2 pl-xl-2 price-info"
          },
          [
            _c("label", [_vm._v("Price")]),
            _vm._v(" "),
            !_vm.job.is_flat_rate
              ? _c("p", { staticClass: "m-0" }, [
                  _vm._v(_vm._s(_vm.job.price_per_hour))
                ])
              : _c("p", { staticClass: "m-0" }, [
                  _vm._v(_vm._s(_vm.job.price))
                ]),
            _vm._v(" "),
            _c("error-field", { attrs: { errors: _vm.errors, field: "price" } })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-2 col-lg-1 col-md-1 col-xl-1 pr-0 pl-lg-2 pl-md-2 pl-xl-2 price-info"
          },
          [
            _c("label"),
            _vm._v(" "),
            _c("customTooltip", {
              attrs: { config: { placement: "right" } },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var isOpen = ref.isOpen
                    var open = ref.open
                    var close = ref.close
                    return _c(
                      "div",
                      {
                        staticStyle: { padding: "0px 5px 0px 5px" },
                        on: { mouseover: open, mouseleave: close }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-home",
                          class:
                            _vm.job.is_small === 1
                              ? "icon-color"
                              : "icon-color2",
                          attrs: { "data-trigger": "" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: isOpen,
                                expression: "isOpen"
                              }
                            ],
                            staticClass: "custom-tooltip",
                            attrs: { "data-popper": "" }
                          },
                          [
                            _c("div", {
                              staticClass: "border-black",
                              attrs: { "x-arrow": "" }
                            }),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.isSmallJob) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    )
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-4 col-lg-1 col-md-1 col-xl-1 pr-0 pl-lg-2 pl-md-2 pl-xl-2 price-info"
          },
          [
            _c("label", [_vm._v("Transaction fee")]),
            _vm._v(" "),
            _c("p", { staticClass: "m-0" }, [
              _vm._v(_vm._s(_vm.job.company.charge_fee || 0) + "%")
            ])
          ]
        ),
        _vm._v(" "),
        _vm.job.company.cash_discount_value > 0 && !_vm.isFlatRate
          ? _c(
              "div",
              {
                staticClass:
                  "col-3 col-lg-1 col-md-1 col-xl-1 pr-0 pl-lg-2 pl-md-2 pl-xl-2 pl-2 price-info"
              },
              [
                _c("label", [_vm._v("Cash Discount")]),
                _vm._v(" "),
                _c("p", { staticClass: "m-0" }, [
                  _vm._v(
                    _vm._s(_vm.job.cash_discount_value) +
                      " " +
                      _vm._s(_vm.job.cash_discount_unit)
                  )
                ])
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-1" }, [
        _c(
          "div",
          {
            staticClass:
              "col-12 col-lg-4 col-md-4 col-xl-4 pr-lg-2 pr-md-2 pr-xl-2 mb-3 mb-xl-0 mb-lg-0 mb-md-0"
          },
          [
            _c(
              "div",
              { staticClass: "select-wrap" },
              [
                _c("label", [_vm._v("Move Size")]),
                _vm._v(" "),
                _c("simple-select", {
                  attrs: {
                    options: _vm.moveSizes,
                    disabled: !_vm.editableFields || _vm.isFlatRate,
                    placeholder: "Select Move Size"
                  },
                  on: { input: _vm.updateOffers },
                  model: {
                    value: _vm.job.move_size_id,
                    callback: function($$v) {
                      _vm.$set(_vm.job, "move_size_id", $$v)
                    },
                    expression: "job.move_size_id"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("error-field", {
              attrs: { errors: _vm.errors, field: "move_size_id" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-6 col-lg-4 col-md-4 col-xl-4 px-lg-2 px-md-2 px-xl-2"
          },
          [
            _c(
              "div",
              { staticClass: "select-wrap" },
              [
                _c("label", [_vm._v("Movers")]),
                _vm._v(" "),
                _c("simple-select", {
                  attrs: {
                    options: _vm.numberOfMovers,
                    disabled: !_vm.editableFields,
                    placeholder: "Select Movers"
                  },
                  on: { input: _vm.updateOffers },
                  model: {
                    value: _vm.job.movers,
                    callback: function($$v) {
                      _vm.$set(_vm.job, "movers", $$v)
                    },
                    expression: "job.movers"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("error-field", {
              attrs: { errors: _vm.errors, field: "movers" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-6 col-lg-4 col-md-4 col-xl-4 pl-lg-2 pl-0 pl-md-2 pl-xl-2"
          },
          [
            _c("div", { staticClass: "select-wrap" }, [
              _c("label", [_vm._v("Trucks")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.job.trucks,
                    expression: "job.trucks"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", disabled: !_vm.editableFields },
                domProps: { value: _vm.job.trucks },
                on: {
                  change: _vm.updateOffers,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.job, "trucks", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _vm.errors
              ? _c("error-field", {
                  attrs: { errors: _vm.errors, field: "trucks" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.errors
              ? _c("error-field", {
                  attrs: { errors: _vm.errors, field: "truck_number" }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.changed && !_vm.job.is_flat_rate
        ? [
            _vm.editableFields
              ? _c("offer", {
                  ref: "offerRef",
                  staticClass: "my-1",
                  attrs: {
                    data: _vm.job,
                    "book-offer-prop": _vm.bookOffer,
                    "button-disabled": _vm.buttonDisabled,
                    "loading-book-button": _vm.loadingBookButton,
                    "booking-phone": _vm.job.company.booking_phone
                  },
                  on: {
                    setOfferError: _vm.setOfferError,
                    "offer-offered": function($event) {
                      _vm.offerOffered = true
                    }
                  }
                })
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.job.company.booking_send_offers
        ? _c("span", [
            _vm.changed && _vm.editableFields && _vm.offerOffered
              ? _c(
                  "div",
                  { staticClass: "flex align-items-end justify-content-end" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-column align-items-center justify-content-center"
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            on: {
                              click: function($event) {
                                _vm.sendJobRescheduleEmail()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          Send reschedule link to customer\n        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("customTooltip", {
                              attrs: { config: { placement: "top" } },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var isOpen = ref.isOpen
                                    var open = ref.open
                                    var close = ref.close
                                    return _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          padding: "0px 5px 0px 5px"
                                        },
                                        on: {
                                          mouseover: open,
                                          mouseleave: close
                                        }
                                      },
                                      [
                                        _vm.job.offers_sent_diff
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "lead-sent-offer-diff",
                                                attrs: { "data-trigger": "" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                Sent " +
                                                    _vm._s(
                                                      _vm.job.offers_sent_diff
                                                    ) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: isOpen,
                                                expression: "isOpen"
                                              }
                                            ],
                                            staticClass: "custom-tooltip",
                                            attrs: { "data-popper": "" }
                                          },
                                          [
                                            _vm.job.offers_sent
                                              ? _c("div", {
                                                  staticClass: "border-black",
                                                  staticStyle: {
                                                    color: "black"
                                                  },
                                                  attrs: { "x-arrow": "" }
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.job.offers_sent) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62d0602f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62d0602f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobRates.vue
// module id = null
// module chunks = 